import { html, type TemplateResult } from 'lit';
import { MarkdownDoc } from '../../data/markdownEngine';

export interface PostListProps {
  posts: MarkdownDoc[];
  onOpenPost: (doc: MarkdownDoc) => void;
}

export function renderPostListPresentation(props: PostListProps): TemplateResult {
  const { posts, onOpenPost } = props;

  if (posts.length === 0) {
    return html`<p style="color: var(--text-muted, #7c7c75);">No entries found.</p>`;
  }

  return html`
    <div class="list-container">
      ${posts.map(
        doc => html`
          <article class="post-item" @click=${() => onOpenPost(doc)}>
            <div class="post-date">${doc.date}</div>
            <div class="post-content">
              <h3>${doc.title}</h3>
              <p class="post-summary">${doc.summary}</p>
              <div class="meta-row">
                <span class="read-time">${doc.readingTime}</span>
                ${doc.tags.map(t => html`<span class="tag-chip">${t}</span>`)}
              </div>
            </div>
          </article>
        `
      )}
    </div>
  `;
}
